﻿window.addEventListener('load', function () {
    var tries = 0;
    var interval = setInterval(function () {
        tries++;

        var container = document.getElementById("freshworks-container");
        if (container) {
            container.style.zIndex = '1029';

            // Move the launcher below the lightbox - Temp solution for #14099
            //const launcher = document.getElementById('launcher-frame');
            //const lightbox = document.getElementById('lightbox-frame');

            //if (launcher && lightbox) {
            //    lightbox.after(launcher);
            //}

            clearInterval(interval);
        }

        if (tries > 20) {
            clearInterval(interval);
        }
    }, 100);
});